import { IxTreeNode } from './IxTreeNode.js';

customElements.define('ix-tree-node', IxTreeNode);
